import { toRefs, reactive } from '@vue/composition-api';
import useCommonModal from '@/compositions/useCommonModal';
import useUsers from '@/api/users';

const useUserActions = (props, entity) => {
  const modalComposition = useCommonModal();
  const { groups, user } = useUsers();

  const state = reactive({
    actions: [],
    selectedUserGroups: [],
    prevSelected: []
  });

  const processActions = handler => {
    state.actions.forEach(item => handler(item));
  };

  const isEnabled = targetObject => {
    return targetObject.enabled;
  };

  const handleChangeGroups = async () => {
    state.prevSelectedUserGroups = entity.value.usersToGroups.map(item => ({
      id: item.userGroup.id,
      connectionId: item.id,
      name: item.userGroup.groupName
    }));

    let listUserGroups = [];

    await groups.load().then(res => {
      listUserGroups = res
        .filter(item => !item.isSystem)
        .map(item => ({
          id: item.id,
          name: item.groupName
        }));
    });

    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'ChangeUserGroups'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/ChangeUserGroups.vue'),
          bind: {
            listUserGroups,
            prevSelectedUserGroups: state.prevSelectedUserGroups,
            id: entity.value.id
          }
        }
      }
    });
  };

  const handleToggleStatus = () => {
    let isEnabled = entity.value.enabled;
    user.update(props.id, {
      enabled: !isEnabled
    });
  };

  const handleEditUser = () => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'EditUser'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/CreateUser.vue'),
          bind: {
            entity: entity.value
          },
          on: {
            close() {
              modalComposition.modal.hide('EditUser');
            }
          }
        }
      }
    });
  };

  const getActions = targetEntity => {
    state.actions = [
      {
        id: 'edit-user',
        text: 'Edit',
        icon: 'mdi-pencil',
        handleAction: handleEditUser,
        _enabled: true
      },
      {
        text: 'Change password',
        icon: 'mdi-key',
        id: 'change-password',
        _enabled: true
      },
      {
        id: 'change-user-group',
        text: 'Change user groups',
        icon: 'mdi-account-multiple-plus',
        handleAction: handleChangeGroups,
        _enabled: true
      },
      {
        id: 'enable-disable',
        text: isEnabled(targetEntity) ? 'Disable' : 'Enable',
        icon: 'mdi-cancel',
        _enabled: true,
        handleAction: handleToggleStatus
      },
      {
        id: 'copy-uuid',
        text: 'Copy UUID',
        icon: 'mdi-content-copy',
        _enabled: true
      },
      {
        id: 'delete',
        text: 'Delete',
        icon: 'mdi-delete',
        _enabled: true
      }
    ];

    return state.actions;
  };

  return {
    processActions,
    getActions
  };
};

export default useUserActions;
